import { Box, Typography, useTheme } from "@mui/material";

function HeaderCardLite({ header, value }) {
  const theme = useTheme();
  return (
    <Box
      boxShadow={5}
      sx={{
        p: 1,
        borderRadius: 8,
        color: theme.palette.background.dark,
        width: "40%",
        border: `5px solid ${theme.palette.earnpati.main}`,
      }}
    >
      <Typography variant="h4" height={"30%"} sx={{ textAlign: "center" }}>
        {header}
      </Typography>
      <Typography
        variant="h6"
        sx={{
          textAlign: "center",
          p: 1,
          mt: 1.5,
          bgcolor: theme.palette.secondary.light,
          color: "#333",
          borderRadius: 3,
        }}
      >
        {value}
      </Typography>
    </Box>
  );
}

export default HeaderCardLite;
